import { FullContainer } from '@gorila-shared-ui/components';
import { generatePath, useParams } from 'react-router-dom';
import { FLEET_REPORTS_PAGE } from '../../../constants/fleet';
import { useStyles } from '../../../hooks/useStyles';
import FleetOperationalList from '../../fleet/reports/FleetOperationalList';
import FleetOperationalReportsFilters from '../../fleet/reports/FleetOperationalReportsFilters';
import CustomBreadcrumbs from '../../shared/CustomBreadcrumbs';

function FleetOperationalReportsPage() {
  const { classes, concatenateClasses, css } = useStyles();
  const { id: workspaceId } = useParams();
  const redirectPath = workspaceId ? generatePath(FLEET_REPORTS_PAGE.route, { id: workspaceId }) : '/';

  return (
    <FullContainer verticalFlex>
      <CustomBreadcrumbs
        historic={[
          {
            path: redirectPath,
            label: 'Reportes',
          },
          {
            label: 'Operaciones',
          },
        ]}
      />
      <FullContainer
        verticalFlex
        classNames={concatenateClasses(classes.basicPageContainer, css({ overflow: 'auto' }))}
      >
        <FleetOperationalReportsFilters />
        <FleetOperationalList />
      </FullContainer>
    </FullContainer>
  );
}

export default FleetOperationalReportsPage;
